<template>
	<div class="my-4">
		<div class="strong mb-2">
			Период и ставка рассрочки
		</div>
		<b-dropdown
			:id="'payment_type_dropdown'"
			v-b-tooltip.blur
			block
			:variant="isValidate === true? 'secondary-outer' : 'outline-danger'"
			menu-class="w-100 mt-2"
			:disabled="loanForm.sending"
			@hide="onHideDropdown"
		>
			<template
				#button-content
				class="rounded-0"
			>
				<b-spinner
					v-if="loanForm.sending"
					style="width: 1.3em; height: 1.3em; margin-right: 15px;"
				/>
				{{ loanPromoCodeText }}
			</template>

			<b-dropdown-item-button
				v-for="(item, index) in loanPromoCodes"
				:key="index"
				type="button"
				name="action"
				class
				:class="{'active': loanPromoCode === item.value}"
				@click="createLoanApplication(item.value, item.text)"
			>
				<span>{{ item.text }}</span>
			</b-dropdown-item-button>
		</b-dropdown>
		<b-form-invalid-feedback :state="loanState">
			<ul v-for="(errors, index) in loanForm.errors" :key="index">
				<li v-for="msg in errors" :key="msg">
					{{ msg }}
				</li>
			</ul>
		</b-form-invalid-feedback>
		<b-container
			v-if="!loanForm.sending && loanForm.error"
			class="d-flex justify-content-center"
		>
			<b-alert
				variant="danger"
				show
				class="mt-3 mb-3"
			>
				{{ loanForm.error }}
			</b-alert>
		</b-container>
		<b-form-invalid-feedback
			id="dropdown-payment-feedback"
			:state="isValidate ? null : false"
		>
			Поле обязательно для заполнения
		</b-form-invalid-feedback>
	</div>
</template>

<script>
/**
 * в @change дополнительно триггерится blur, т.к. похоже у изначального компонента события blur нет.
 * Blur необходим, т.к. при срабатывании этого события проходит валидация.
 */
import checkoutFormStep from '@/mixins/checkoutFormStep';
import {
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_LOCAL_META_DATA,
} from '~/store/checkout';

export default {
	name: 'DropdownPayment',
	mixins: [checkoutFormStep],
	props: {
		formData: {
			type: Object,
			default: () => ({}),
		},
		eventPayment: {
			type: Object,
			default: () => ({}),
		},
		field: {
			type: Object,
			default: () => ({}),
		},
		// eslint-disable-next-line vue/require-prop-types
		value: { default: null },
	},
	data() {
		return {
			loanForm: {
				attempted: false,
				sending: false,
				message: null,
				errors: {},
			},
			loanPromoCode: '',
			loanPromoCodeText: 'Выберите значение',
			loanPromoCodes: [
				{ value: 'installment_0_0_3_5,5_3,8', text: '3 месяца 6%' },
				{ value: 'installment_0_0_3_6,0', text: '4 месяца 7,5%' },
				{ value: 'installment_0_0_4_6,9', text: '6 месяцев 10,2%' },
				{ value: 'installment_0_0_4_7,5', text: '10 месяцев 15,5' },
				{ value: 'installment_0_0_6_9,5', text: '12 месяцев 18%' },
				{ value: 'installment_0_0_6_10,2', text: '3 месяца 5,5%' },
				{ value: 'installment_0_0_10_14,4_6,4', text: '4 месяца 6,9%' },
				{ value: 'installment_0_0_10_15,5', text: '6 месяцев 9,5%' },
				{ value: 'installment_0_0_12_16,6_5,8', text: '10 месяцев 14,4%' },
				{ value: 'installment_0_0_12_18', text: '12 месяцев 16,6%' },
			],
			paymentProvider: null,
			isValidate: true,
		};
	},
	computed: {
		/**
		 * true - valid
		 * false - invalid
		 * null - not validated
		 * */
		loanState() {
			if (this.loanForm.attempted) {
				return Object.keys(this.loanForm.errors).length === 0;
			}
			return null;
		},
	},
	mounted() {
		const dropdown = document.getElementById('payment_type_dropdown__BV_toggle_');
		dropdown.click();
	},
	methods: {
		onHideDropdown() {
			this.isValidate = true;
			if (this.loanPromoCode === '') {
				this.isValidate = false;
			}
		},
		async createLoanApplication(promo, promotext) {
			this.loanForm.sending = true;
			this.loanForm.error = null;
			this.loanForm.errors = {};

			this.$nextTick(() => {
				this.loanForm.attempted = true;
			});

			this.loanPromoCode = promo;
			this.loanPromoCodeText = promotext;
			this.paymentProvider = 'tinkoff_loan_applications';

			try {
				await this.$api.doLoanApplication({
					paymentProvider: 'tinkoff_loan_applications',
					loanPromoCode: this.loanPromoCode,
					formId: this.formData.id,
					eventId: this.eventPayment.id,
					uniqueId: this.$store.state.uniqueId.uniqueId,
				});

				await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
					formId: this.formData.id,
					localMeta: {
						isShowDocumentInfoMessage: false,
					},
				});

				await this.$store.dispatch(
					`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
					{ formId: this.formData.id },
				);
			} catch (error) {
				this.$logger.log(error);
				try {
					const {
						message,
						errors,
					} = this.$api.getValidationFromError(error);
					this.loanForm.error = message;
					this.loanForm.errors = errors;
				} catch {
					this.loanForm.error = 'Что-то пошло не так';
					this.loanForm.errors = {};
				}
			} finally {
				this.loanForm.sending = false;
			}
		},
		checkValidation(form) {
			return this.isValidate;
		},
	},
};
</script>

<style scoped>

</style>
